import { render } from "./Pager.vue?vue&type=template&id=3d64a6bf&scoped=true"
import script from "./Pager.vue?vue&type=script&lang=js"
export * from "./Pager.vue?vue&type=script&lang=js"

import "./Pager.vue?vue&type=style&index=0&id=3d64a6bf&scoped=true&lang=css"

import exportComponent from "/home/farena/workspace/smt/smt_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d64a6bf"]])

export default __exports__